<template>
  <v-layout column>
    <v-flex xs12 lg6 offset-sm3>
      <div class="header">
        <v-card-media src="/static/doc-images/lists/samadhi.jpg" height="200px">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
      </div>
      <div class="content">
        <template>

          <!-- <v-list two-line>
            <v-divider divider='true' inset='true'></v-divider>
            <v-list-tile avatar :href="amartithiLiveUrl" target="_blank">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/video.png'/>
              </v-list-tile-avatar>
              <v-list-tile-content>
              <v-list-tile-title>
                Amartithi-2025 Live
              </v-list-tile-title>
              <v-list-tile-sub-title>
                Live streaming from Meher Baba's Tomb
              </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-list two-line>
						<v-list-tile avatar :to="{ name: 'token' }">
							<v-list-tile-avatar>
							<div v-for="picture in getToken()" v-bind:key="picture.id" class="image-card" style="background-color: #fff; padding: 5px; border-radius: 50%; box-shadow: 0 2px 4px 0 rgba(163, 162, 162, 0.9);">
								<div class="image-card__picture">
									<img :src= "picture.url" align='center' style="height: 32.55px; width: 32.5px;"/>
								</div>
							</div>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									Amarthiti Current Darshan Token
								</v-list-tile-title>
								<v-list-tile-sub-title>
									<span class='grey--text text--darken-2'>Available on 31<sup>st</sup> January</span>
								</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>

          <v-list two-line>
            <v-divider divider='true' inset='true'></v-divider>
            <v-list-tile :href="schedulePDF" avatar target="_blank">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/schedule-clock.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Amartithi Program Schedule
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list> -->

          <!-- <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :href="donationsUrl" target="_blank">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/ambppct.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Amartithi-2025 Donations
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <span class='grey--text text--darken-2'>(Amartithi Registrations)</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list> -->

          <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :to="{ name: 'Donations' }">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/shake-hand.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Regular Donations to Trust
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <!-- <v-list two-line>
						<v-divider divider="true" inset="true"></v-divider>
						<v-list-tile avatar :to="{ name: 'Schedule' }">
							<v-list-tile-avatar>
							  <img src='/static/doc-images/lists/schedule-clock.png'/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									Amartithi Program Schedule
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-divider divider="true" inset="true"></v-divider>
					</v-list> -->

          <!-- <v-list two-line>
						<v-divider divider="true" inset="true"></v-divider>
						<v-list-tile avatar :to="{ name: 'Amartithi' }">
							<v-list-tile-avatar>
							  <img src='/static/doc-images/lists/ambppct.png'/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									Amartithi-2021 Live
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list> -->
          <!-- <v-list two-line>
						<v-divider divider='true' inset='true'></v-divider>
              <v-list-tile :href="amartithiUrl" avatar>
                <v-list-tile-avatar>
                  <img src='/static/doc-images/lists/events.png'/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    50th Amartithi Programme Schedule
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    Schedule may be subject to change
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
					</v-list> -->

          <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :to="{ name: 'bio' }">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/bio.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Biography
                </v-list-tile-title>
                <!-- <v-list-tile-sub-title>
									<span class='grey--text text--darken-2'>Meher Baba</span> — No amount of prayer or meditation can do what helping others can do.!
								</v-list-tile-sub-title> -->
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :to="{ name: 'air' }">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/how to reach.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  How to reach
                </v-list-tile-title>
                <!-- <v-list-tile-sub-title>
									<span class='grey--text text--darken-2'>Meherabad</span> — is located on Daund Road six kilometers outside the city of Ahmednagar, Maharashtra, India
								</v-list-tile-sub-title> -->
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :to="{ name: 'piligrim' }">
              <v-list-tile-avatar>
                <img src='static/doc-images/lists/Accomdation.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Accommodation
                </v-list-tile-title>
                <!-- <v-list-tile-sub-title>
									Reservations for Meher Pilgrim Retreat and Reservations for Hostels or Dharmshala
								</v-list-tile-sub-title> -->
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-list two-line>
						<v-divider divider="true" inset="true"></v-divider>
						<v-list-tile avatar :href="liveUrl" target="_blank">
							<v-list-tile-avatar>
								<img src="/static/doc-images/lists/samadhi.jpg"/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									AMB Tomb Shrine Virtual Darshan
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>

          <!-- <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :to="{ name: 'Donations' }">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/shake-hand.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Regular Donations to Trust
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list> -->

          <!-- <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :href="donationsUrl" target="_blank">
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/ambppct.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Amartithi-2025 Donations
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <span class='grey--text text--darken-2'>(Download Amartithi Donation Receipt)</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list> -->

          <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :to="{ name: 'Prayers' }">
              <v-list-tile-avatar>
                <img src="/static/doc-images/lists/prayer.png" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Prayers
                </v-list-tile-title>
                <!-- <v-list-tile-sub-title>
									<span class='grey--text text--darken-2'>Meher Baba</span> — Arti and Prayers at Samadhi daily at 7:00AM and 7:00PM.
								</v-list-tile-sub-title> -->
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-list two-line>
            <v-divider divider="true" inset="true"></v-divider>
            <v-list-tile avatar :href="libraryUrl" target="_blank">
              <v-list-tile-avatar>
                <img src="/static/doc-images/lists/digital-library-e-book.jpg" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Online Library
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <!-- <v-list two-line>
						<v-divider divider="true" inset="true"></v-divider>
						<v-list-tile avatar :to="{ name: 'Amartithi' }">
							<v-list-tile-avatar>
							  <img src='/static/doc-images/lists/ambppct.png'/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									Amartithi-2020
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list> -->
          <v-list two-line>
            <v-divider divider='true' inset='true'></v-divider>
            <!-- <a :href="eventUrl" style="text-decoration: none;"> -->
            <v-list-tile :href="eventUrl" avatar>
              <v-list-tile-avatar>
                <img src='/static/doc-images/lists/events.png' />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Events
                </v-list-tile-title>
                <!-- <v-list-tile-sub-title>
                    Weekly Pilgrim Events Calendar
                  </v-list-tile-sub-title> -->
              </v-list-tile-content>
            </v-list-tile>
            <!-- </a> -->
          </v-list>
          <!--<v-list two-line>
						<v-divider divider="true" inset="true"></v-divider>
						<v-list-tile avatar :to="{ name: 'Historicsites' }">
							<v-list-tile-avatar>
							  <img src='static/doc-images/lists/Historic.png'/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									Historic Sites
								</v-list-tile-title>
								<v-list-tile-sub-title>
									Meherabad
								</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>-->

          <!-- <v-list two-line>
						<v-divider divider="true" inset="true"></v-divider>
						<v-list-tile avatar :href="aboutUsLink" target="_blank">
							<v-list-tile-avatar>
								<img src="/static/doc-images/lists/notice-icon.png"/>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									About us
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list> -->
        </template>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import { reduce } from 'lodash'
  import {eventBus} from '../Eventbus/eventbus.js'
import firebase from 'firebase'
  export default {
    data () {
      return {
        token: '',
        tokenUrl: '',
        eventUrl: '',
        schedulePDF: '',
        amartithiUrl: '',
        aboutUsLink: 'https://app.meherjee.com/service-folder/WZXWBNHd1efZSRy1uGtv/0PS6iqyfg8UsnN2nV709',
        libraryUrl: 'https://avatarmeherbabatrust.org/index.php/online-library-2/',
        donationsUrl: 'https://ambppct-donations.herokuapp.com/', // 'https://ambppct.herokuapp.com/',
        generalDonationsUrl: 'https://rzp.io/l/ambppct', // 'https://ambppct-donations-gen.herokuapp.com/'
        amartithiLiveUrl: 'https://youtube.com/@Amartithi2012?si=PH0p-9GBgFKjo3mx', // 'https://www.youtube.com/@meherabadchannel/streams' // 'https://www.youtube.com/channel/UCeGuYMaYBeh5JY87rmcZE_A/live'
        liveUrl: 'https://www.youtube.com/@meherabadchannel/streams' // 'https://www.youtube.com/channel/UCeGuYMaYBeh5JY87rmcZE_A/live'
      }
    },
    created () {
      firebase.storage().ref().child('56th Amartithi Programme Timetable 2025.pdf').getDownloadURL().then(url => {
        this.schedulePDF = url
      })
      eventBus.$on('tokenChanged', (token) => {
        console.log(token)
        this.token = token
        this.updateToken()
      })
      // this.map()
      firebase.database().ref('WeeklyUpdate/url').once('value').then((snapchot) => {
        this.eventUrl = snapchot.val()
        // location.href = snapchot.val()
      })
      // firebase.database().ref('50th Amartithi/url').once('value')
      //   .then((snapchot) => {
      //     this.amartithiUrl = snapchot.val()
      //   })
    },
    methods: {
      /* map () {
        firebase.database().ref('WeeklyUpdate/url').once('value')
        .then((snapchot) => {
          console.log(snapchot)
          // this.eventUrl = snapchot.val()
          location.href = snapchot.val()
        })
      }, */
      displayDetails (id) {
        this.$router.push({name: 'detail', params: { id: id }})
      },
      updateToken () {
        var storageRef = firebase.storage().ref()
        var file = this.token
        var thisRef = storageRef.child(file + '.png')
        thisRef.getDownloadURL().then((url) => {
          this.tokenUrl = url
          var postUrl = {
            TokenNumber: file,
            url: this.tokenUrl
          }
          var updates = {}
          updates['Trust/-L23hfuuPh-POpu-oE03'] = postUrl
          return firebase.database().ref().update(updates)
        })
      },
      getToken () {
        if (navigator.onLine) {
          this.saveTokenToCache()
          return reduce(this.$root.Trust, (Token, firebaseEntry) => {
            Token[firebaseEntry['.key']] = {
              url: firebaseEntry['url']
            }
            return Token
          }, {})
        } else {
          var token = JSON.parse(window.localStorage.getItem('Token'))
          return token
        }
      },
      saveTokenToCache () {
        this.$root.$firebaseRefs.Trust.once('value', (snapchot) => {
          let cachedToken = {}
          snapchot.forEach((catSnapchot) => {
            cachedToken[catSnapchot.key] = catSnapchot.val()
          })
          window.localStorage.setItem('Token', JSON.stringify(cachedToken))
        })
      },
      donations () {
        location.href = 'https://ambppct.herokuapp.com/'
      },
      live () {
        location.href = 'https://youtu.be/j_mbhuKw9_I'
      }
    },
    mounted () {
      this.saveTokenToCache()
    }
  }
</script>
<style>
.header
	{
		height:200px;
		position: absolute;
		top: 50px;
		left:0px;
		right:0px;
		bottom:0px;
	}
.content
	{
		position:absolute;
		top: 250px;
		left:0px;
		right:0px;
		bottom:0px;
		overflow-y:scroll;
	}
.btn--right
	{
    bottom: 3px;
    right: 12px;
	}
	.list__tile__sub-title {
    font-size: 15px;
	}
	.list__tile {
    font-size: 17px;
	}
  .list {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?5ac6219c